import AgreementModal from "assets/locales/ja/common/AgreementModal.js"
import DisplayAgreementContents from "assets/locales/ja/displayAgreement/DisplayAgreementContents.js"
import DisplayAgreementSummary from "assets/locales/ja/displayAgreement/DisplayAgreementSummary.js"
import DisplayAgreementInfo from "assets/locales/ja/displayAgreement/DisplayAgreementInfo.js"
import Footer from "assets/locales/ja/common/Footer.js"
import Header from "assets/locales/ja/common/Header.js"
import InfoIconUpdate from "assets/locales/ja/information/InfoIconUpdate.js"
import Information from "assets/locales/ja/information/Information.js"
import Menu from "assets/locales/ja/common/Menu.js"
import NoticeAgreementsSettingContents from "assets/locales/ja/noticeAgreementsSetting/NoticeAgreementsSettingContents.js"
import NoticeAgreementsSettingSummary from "assets/locales/ja/noticeAgreementsSetting/NoticeAgreementsSettingSummary.js"
import NoticeConfigContents from "assets/locales/ja/noticeConfig/NoticeConfigContents.js"
import NoticeConfigSummary from "assets/locales/ja/noticeConfig/NoticeConfigSummary.js"
import OneTouchContents from "assets/locales/ja/oneTouch/OneTouchContents.js"
import SeparateSettingContents from "assets/locales/ja/separateSetting/SeparateSettingContents.js"
import Snackbar from "assets/locales/ja/common/Snackbar.js"
import Tab from "assets/locales/ja/common/Tab.js"
import ThirdPartyChangeContents from "assets/locales/ja/thirdParty/ThirdPartyChangeContents.js"
import ThirdPartyContents from "assets/locales/ja/thirdParty/ThirdPartyContents.js"
import ThirdPartyCurrentContents from "assets/locales/ja/thirdParty/ThirdPartyCurrentContents.js"
import ThirdPartyModal from "assets/locales/ja/thirdParty/ThirdPartyModal.js"
import ThirdPartyOneTouchItem from "assets/locales/ja/thirdParty/ThirdPartyOneTouchItem.js"
import ThirdPartySummary from "assets/locales/ja/thirdParty/ThirdPartySummary.js"
import TopContents from "assets/locales/ja/top/TopContents.js"
import TopInformation from "assets/locales/ja/top/TopInformation.js"
import TopSummary from "assets/locales/ja/top/TopSummary.js"
import TopAgreements from "assets/locales/ja/top/TopAgreements.js"
import LocationSummary from "assets/locales/ja/location/LocationSummary.js"
import LocationCheckContents from "assets/locales/ja/location/LocationCheckContents.js"
import LocationChangeContents from "assets/locales/ja/location/LocationChangeContents.js"
import LocationModal from "assets/locales/ja/location/LocationModal.js"
import LocationAgreeModal from "assets/locales/ja/location/LocationAgreeModal.js"
import LocationDisagreeModal from "assets/locales/ja/location/LocationDisagreeModal.js"

export default {
  ...AgreementModal,
  ...DisplayAgreementContents,
  ...DisplayAgreementSummary,
  ...DisplayAgreementInfo,
  ...Footer,
  ...Header,
  ...InfoIconUpdate,
  ...Information,
  ...Menu,
  ...NoticeAgreementsSettingContents,
  ...NoticeAgreementsSettingSummary,
  ...NoticeConfigContents,
  ...NoticeConfigSummary,
  ...OneTouchContents,
  ...SeparateSettingContents,
  ...Snackbar,
  ...Tab,
  ...ThirdPartyChangeContents,
  ...ThirdPartyContents,
  ...ThirdPartyCurrentContents,
  ...ThirdPartyModal,
  ...ThirdPartyOneTouchItem,
  ...ThirdPartySummary,
  ...TopContents,
  ...TopInformation,
  ...TopSummary,
  ...TopAgreements,
  ...LocationSummary,
  ...LocationCheckContents,
  ...LocationChangeContents,
  ...LocationModal,
  ...LocationAgreeModal,
  ...LocationDisagreeModal,
}
